// @ts-nocheck
import { BillToModel } from "@insite/client-framework/Types/ApiModels";
import constants from "@store/constants";

const getIsB2BBillTo = (billTo: BillToModel | undefined) => {
    return billTo?.properties?.customerType === constants.customerType.b2b;
};

export default getIsB2BBillTo;
